import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { PermissionCheckService } from 'app/shared/services/core/permission-check.service';
import { PerfilEnum } from 'app/shared/models/core/security/perfil.enum';

/**
 * Diretiva estrutural para controlar a exibição de elementos baseado no perfil do usuário.
 *
 * Uso:
 * ```html
 * <!-- Mostrar apenas para ADM_SISTEMA -->
 * <button *hasProfile="[1]">Apenas Admin</button>
 *
 * <!-- Mostrar para ADM_SISTEMA e ADM_IMOBILIARIA -->
 * <button *hasProfile="[1, 2]">Admin ou Imobiliária</button>
 *
 * <!-- Usando o enum diretamente (recomendado) -->
 * <button *hasProfile="[PerfilEnum.ADM_SISTEMA, PerfilEnum.ADM_IMOBILIARIA]">...</button>
 * ```
 */
@Directive({
  selector: '[hasProfile]',
  standalone: true
})
export class HasProfileDirective implements OnInit {

  private allowedProfiles: PerfilEnum[] = [];
  private hasView = false;

  @Input()
  set hasProfile(profiles: PerfilEnum[] | number[]) {
    this.allowedProfiles = profiles as PerfilEnum[];
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionCheckService
  ) {}

  ngOnInit(): void {
    this.updateView();
  }

  private updateView(): void {
    const hasPermission = this.permissionService.hasProfile(...this.allowedProfiles);

    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
